import { render } from "./InteractiveSquare.vue?vue&type=template&id=0acb9214&scoped=true"
import script from "./InteractiveSquare.vue?vue&type=script&lang=js"
export * from "./InteractiveSquare.vue?vue&type=script&lang=js"

import "./InteractiveSquare.vue?vue&type=style&index=0&id=0acb9214&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0acb9214"]])

export default __exports__